import React, { useState } from 'react';
import { motion } from "framer-motion";
import hero_bg from "../../../assets/images/hero/hero-2.png";
import draftLegal_hero_bg from "../../../assets/images/draftlegal_landing.png";
import shap_2 from "../../../assets/images/shape/shape-2.png";
import { slideUp } from '../../../utils/slideUp'
import ModalVideo from 'react-modal-video';
import "react-modal-video/scss/modal-video.scss";
import { Link } from 'react-router-dom';

/* bannerOne.jsx */
/* securityOne.jsx */
/* aboutOne.jsx */
/* servicesOne.jsx */

const BannerOne = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <section className="banner-area" style={{ backgroundColor:'#f5f5f5' }}>
      <div className="container-fluid">
        <motion.div className="row align-items-center"
          //initial="offscreen"
          //whileInView="onscreen"
          //variants={slideUp(1)}
          //viewport={{ once: true, amount: 0.4 }}
        >
          <div className="col-lg-6">
            <div className="banner-content">
              <div className="title">
                <h1 style={{ color:'#272b3a' }}>AI 法律合約生成</h1>
                <p className="glow-button glow-frequent" style={{ color:'#317c73', fontSize:'20px', padding: '0' }}>
                  法律文件，彈指即現
                </p>
              </div>
              <div className="banner-button d-flex align-items-center">
                <Link className="demo text-decoration-none" to="/contract">找尋合約類型</Link>
                <div className="play-btn d-flex align-items-center">
                  <div onClick={() => setOpen(true)} className="text-decoration-none popup-youtube icon " >
                    <i style={{ color: '#317c73' }} className="ri-play-mini-fill"></i>
                  </div>
                  <div onClick={() => setOpen(true)} style={{ color: '#317c73' }} className="popup-youtube">
                    觀看使用教學
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-image">
              <img src={draftLegal_hero_bg} alt="banner-image" />
            </div>
          </div>
        </motion.div>
      </div>
      {/*
      <div className="shape">
        <div className="shape-2">
          <img src={shap_2} alt="shape" />
        </div>
      </div>
      */}
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="0O2aH4XLbto"
        onClose={() => setOpen(false)}
      />
    </section>
  )
}

export default BannerOne;




